import {
	type FileSchedule,
	MissingFileAction,
	PostRetrievalAction,
	type RetrievalMethod,
	RetrievalMethodType,
	ScheduleFrequency,
	SftpSelectionStrategy,
} from '@today/types'

// What the form starts a new method or schedule with (TO-391). The server
// checks every value on save; these only spare the admin typing the common case.

/** The order the method toggles are shown in. */
export const METHOD_TYPES: readonly RetrievalMethodType[] = [
	RetrievalMethodType.SFTP_PULL,
	RetrievalMethodType.API,
	RetrievalMethodType.WEB,
]

export const METHOD_LABELS: Readonly<Record<RetrievalMethodType, string>> = {
	[RetrievalMethodType.SFTP_PULL]: 'SFTP pull',
	[RetrievalMethodType.API]: 'API upload',
	[RetrievalMethodType.WEB]: 'web upload',
}

/** A new method of `type`, ready to edit. */
export const newMethod = (type: RetrievalMethodType): RetrievalMethod => {
	if (type === RetrievalMethodType.SFTP_PULL) {
		return {
			type,
			connectorId: '',
			remoteDirectory: '/',
			filenamePattern: '*',
			selectionStrategy: SftpSelectionStrategy.NEWEST_MATCHING,
			minimumAgeSeconds: 0,
			postRetrieval: { action: PostRetrievalAction.LEAVE, moveToDirectory: null },
		}
	}
	return { type, filenamePattern: '*', limits: { maxFileSizeBytes: 10_485_760, maxFilesPerDay: 10 } }
}

export const NEW_SCHEDULE: Readonly<FileSchedule> = {
	frequency: ScheduleFrequency.DAILY,
	daysOfWeek: [],
	dayOfMonth: null,
	timezone: 'Europe/Madrid',
	after: '06:00',
	expectedBefore: '08:00',
	missingGracePeriodMinutes: 30,
	missingAction: MissingFileAction.ALERT,
}

/** ISO weekday numbers (1 = Monday) with their names. */
export const WEEKDAYS: readonly { day: number; name: string }[] = [
	{ day: 1, name: 'Monday' },
	{ day: 2, name: 'Tuesday' },
	{ day: 3, name: 'Wednesday' },
	{ day: 4, name: 'Thursday' },
	{ day: 5, name: 'Friday' },
	{ day: 6, name: 'Saturday' },
	{ day: 7, name: 'Sunday' },
]
